<template>
<div class="con">
    <div class="title">
        <h2>사전 유의사항</h2>
        <p>아래의 유의사항을 꼭 확인해 주세요.</p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
        <div class="apply-agree-wrap">
            <div class="apply-agree" v-for="(item, index) of agreeInfo" :key="index">
                <input type="checkbox" v-model="item.agree" class="option-input radio" name="example" checked>
                <label for="" class="">
                    <span class=""></span>
                    <span class="agree-text pointer" @click="item.agree = !item.agree">{{item['agree_title' + (index + 1)]}}</span>
                </label>
                <p class="preline" v-html="item['agree_contents' + (index + 1)]" style="max-height:500px;">
                </p>
                <!-- <textarea style="width:100%;" v-html="item['agree_contents' + (index + 1)]"></textarea> -->
            </div>
            <div class="apply-agree">
                <input type="checkbox" v-model="isAllAgree" @click="allAgree()" class="option-input radio" name="example">
                <label for="" class="">
                    <span class=""></span>
                    <span class="pointer" @click="allAgree()">모두 동의합니다.</span>
                </label>
            </div>
        </div>
    </div>
    <div class="apply-agree-btn">
        <button type="button" :class="setButtonColor()" @click="agree()">위 사전 유의사항에 동의합니다.</button>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        isStandardAgree: false,
        isWithdrawAgree: false,
        isAllAgree: false,
        agreeInfo: [],

        pointColor: 'blue'
    }),

    mounted() {
        this.pointColor = sessionStorage.getItem('pointColor')
        var summaryIdx = sessionStorage.getItem('mainIdx')
        var params = {
            summaryIdx: summaryIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/agree/${summaryIdx}`, {
            params: params
        }).then(res => {
            // console.log('res', res)
            if (res.data.err === 0) {
                var idx = 0
                for (var item of Object.keys(res.data.agreeInfo)) {
                    if (item.includes('agree_contents')) {
                        idx += 1
                    }
                }
                
                for (var i = 1; i <= idx; i++) {
                    var tempObj = {}
                    tempObj['agree'] = false
                    tempObj['agree_title' + i.toString()] = res.data.agreeInfo['agree_title' + i.toString()]
                    tempObj['agree_contents' + i.toString()] = res.data.agreeInfo['agree_contents' + i.toString()]
                    this.agreeInfo.push(tempObj)
                }
                // console.log('this.agreeInfo', this.agreeInfo)
            } else {
                alert(res.data.result)
            }
        })
    },

    watch: {
        // 오브젝트 안에 각각 동의 여부를 감지하는 로직
        agreeInfo: {
            handler() {
                var check = true
                for (let item of this.agreeInfo) {
                    if (!item.agree) {
                        check = false
                        break
                    }
                }

                if (check) {
                    this.isAllAgree = true
                } else {
                    this.isAllAgree = false
                }
            },
            deep: true
        }
    },

    methods: {
        setButtonColor() {
            if (this.pointColor === 'Blue') {
                return 'blue'
            } else if (this.pointColor === 'Red') {
                return 'red'
            } else if (this.pointColor === 'Green') {
                return 'green'
            }
        },
        // 모두 동의합니다 버튼
        allAgree() {
            if (!this.isAllAgree) {
                for (let item of this.agreeInfo) {
                    item.agree = true
                }
            } else {
                for (let item of this.agreeInfo) {
                    item.agree = false
                }
            }
        },
        // 약관 동의 검사 및 다음 페이지 이동
        agree() {
            if (!this.isAllAgree) {
                alert('위의 모든 약관에 동의해주세요')
                return false
            } else {
                var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                var idx = pOrder.indexOf('terms') + 1
                sessionStorage.setItem('step', pOrder[idx])
                this.$router.push(`/user/reg/${pOrder[idx]}`)
            }
        }
    }
}
</script>

